import 'react';
import { MdLens } from '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import { useEditor } from '../../hooks/useEditor.js';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../contexts/internal/StickyContext.js';
import '../../contexts/internal/EditorContext.js';
import 'qs';
import 'query-string';
import '@bucketplace/bucket-log';
import Portal from '../Portal/Portal.js';
import Tooltip from '../Tooltip/Tooltip.js';
import { Container, Button } from './Toolbar.style.js';

function Toolbar(_ref) {
  var tools = _ref.tools,
    onSelect = _ref.onSelect;
  var _useEditor = useEditor(),
    components = _useEditor.components;
  function handleClick(type) {
    return function (e) {
      e.stopPropagation();
      onSelect(type);
    };
  }
  return jsx(Portal, {
    containerSelector: "#canvas"
  }, jsx(Container, null, tools.map(function (type) {
    var _components$type$rend, _components$type;
    return jsx(Tooltip, {
      key: type,
      message: components[type].label || type
    }, jsx(Button, {
      onClick: handleClick(type),
      type: "button"
    }, ((_components$type$rend = (_components$type = components[type]).renderIcon) === null || _components$type$rend === void 0 ? void 0 : _components$type$rend.call(_components$type, {})) || jsx(MdLens, null)));
  })));
}

export { Toolbar as default };
//# sourceMappingURL=Toolbar.js.map
